export const getewaysData = {
    saman: {logo: "saman.png", title: "بانک سامان"},
    sadad: {logo: "sadad.png", title: "بانک ملی"},
    sina: {logo: "saman.png", title: "بانک سینا"},
    pasargad: {logo: "pasargad.svg", title: "بانک پاسارگاد"},
    "saman-pars": {logo: "saman.png", title: "بانک سامان"},
    "gardeshgari-pars": {logo: "saman.png", title: "بانک گردشگری"},
    "asan-pardakht": {logo: "asan-pardakht.png", title: "بانک شهر"},
    "asan-pardakht-pars": {logo: "asan-pardakht.png", title: "بانک شهر"},
    "mellat-pars": {logo: "behpardakht.png", title: "بانک ملت"},
};
